import { render, staticRenderFns } from "./c-images-viewer.vue?vue&type=template&id=79167b2e&"
import script from "./c-images-viewer.vue?vue&type=script&lang=js&"
export * from "./c-images-viewer.vue?vue&type=script&lang=js&"
import style0 from "./c-images-viewer.vue?vue&type=style&index=0&id=79167b2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports